import { localize } from "render/context/InternationalizationContext";

export const Trans = {
  clinicalStudy: localize({
    en_GB: "Part of a clinical study",
    sv_SE: "Del av en klinisk studie",
  }),
};
